import React from "react";
import { OrganisationOUT } from "api-client";
import { observer } from "mobx-react-lite";
import useSidebarMenu from "../useSidebarMenu";
import DashboardMenu, { DashboarMenuItem } from "./DashboardMenu";

const LCADashboards = ({ organisation }: { organisation: OrganisationOUT }) => {
  const {
    EPDListMenuItem,
    lcaDashboardMenuItem,
    portfolioScreenerMenuItem,
    ProductListMenuItem,
  } = useSidebarMenu(organisation.id);

  const menuItems: DashboarMenuItem[] = [
    lcaDashboardMenuItem,
    portfolioScreenerMenuItem,
    ProductListMenuItem,
    EPDListMenuItem,
  ];

  return <DashboardMenu menuItems={menuItems} />;
};

export default observer(LCADashboards);
